import React, { useState, useEffect } from 'react';
import {  makeStyles } from '@material-ui/core/styles';

import {
	Visibility,
	FilterList,
	ConfirmationNumber,
	Close,
} from '@material-ui/icons';

import { withLocalize } from 'react-localize-redux';

import {
	Button,
	IconButton,
	Paper,
	Typography,
	Toolbar,
	Box,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	AppBar,
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	Chip,
	LinearProgress,
	CircularProgress,
	Grid,
	Link,
	Slide,
} from '@material-ui/core';

import Format from 'date-fns/format';

import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';

import { useHistory } from 'react-router-dom';

import MUIDataTable from 'mui-datatables';

import { useSnackbar } from 'notistack';

import {
  FinanceService,
} from './../../utils/web_config_2';

import UserInfo from './login_info';

import DateFnsUtils from '@date-io/date-fns';

import axios from 'axios';

import Chart from 'react-apexcharts';

import Skeleton from '@material-ui/lab/Skeleton';
import data from './data';
import { set } from 'date-fns';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction='up' ref={ref} {...props} />;
});

const useStyles1 = makeStyles((theme) => ({
	root: {
		flexShrink: 0,
		flexFlow: 1,
		[theme.breakpoints.up('sm')]: {
			marginLeft: 250,
		},
	},
	btn: {
		textTransform: 'capitalize',
	},
	formTitle: {
		flexGrow: 1,
	},
	paper: {
		padding: theme.spacing(2),
		textAlign: 'center',
		color: theme.palette.text.secondary,
		height: 300,
		elevation: 0,
	},
	appBar: {
		position: 'relative',
	},
	title: {
		marginLeft: theme.spacing(2),
		flex: 1,
	},
}));

function ServiceFeeReport() {
	const classes = useStyles1();

	const [operatorData, setOperatorData] = useState({});

	const { enqueueSnackbar, closeSnackbar } = useSnackbar();

	const [reportsMessage, setReportsMessage] = useState('Loading...');
	const [reportTitle, setReportTitle] = useState('Service Fee Report');


	 const columns = [
			{
				name: 'code',
				label: 'Member Code',
				options: {
					filter: true,
					sort: true,
					customBodyRender: (value, tableMeta, updateValue) => {
						return (
							<Typography color='primary'>
								<Link
									href='#'
									onClick={() =>
										get_detailed_report({
											member_code: value,
											date: date.value,
											status: status.value,
										})
									}
								>
									{value}
								</Link>
							</Typography>
						);
					},
				},
			},
			{
				name: 'name',
				label: 'Member Name',
				options: {
					filter: true,
					sort: true,
				},
			},
			{
				name: 'tin_number',
				label: 'TIN Number',
				options: {
					filter: true,
					sort: true,
				},
			},
			{
				name: 'total_sales',
				label: 'Total Sales',
				options: {
					filter: true,
					sort: true,
				},
			},
			{
				name: 'service_fee',
				label: 'Service Fee',
				options: {
					filter: true,
					sort: true,
				},
			},
			{
				name: 'status',
				label: 'Status',
				options: {
					filter: true,
					sort: true,
				},
			},
		];
    
	const options = {
		textLabels: {
			body: {
				noMatch: reportsMessage,
			},
		},
		filterType: 'checkbox',
		download: true,
		responsive: 'standard',
		selectableRows: false,
		rowsPerPage: 10,
		elevation: 0,
		customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
			<Box>
				<Chip
					className={classes.chip}
					icon={<Visibility />}
					color='primary'
					variant='outlined'
					label='View details'
					onClick={() => {
						var id = displayData[selectedRows.data[0]['index']]['data'][0];
						console.log('ticket id', id);
					}}
				/>
			</Box>
		),
	};

	useEffect(() => {
		var data = {};
		const data1 = localStorage.getItem('nx_op');
		if (data1 != null) {
			data = JSON.parse(data1);
		}

		setOperatorData(data);

		get_servicefee_report(data.token);
	}, []);


	const [amounts, setAmounts] = useState([]);
	const [labels, setLabels] = useState([]);

	const [revenue, setRevenue] = useState([]);

	const [currency, setCurrency] = useState('');

	const pos_performance = {
		options: {
			series: [],
			chart: {
				width: 380,
				type: 'pie',
			},

			labels: labels,
			legend: {
				position: 'right',
				itemMargin: {
					horizontal: 0,
				},
			},
			responsive: [
				{
					breakpoint: 480,
					options: {
						chart: {
							width: 280,
							height: 280,
						},
						legend: {
							position: 'right',
						},
					},
				},
			],
		},
	};

	// fee revenue

	const revenue_fee = {
		options: {
			series: [
				{
					name: 'Revenue',
					data: revenue,
				},
			],
			chart: {
				height: 350,
				type: 'bar',
				tools: {
					download: false,
					selection: false,
					pan: false,
					reset: false,
				},
			},
			plotOptions: {
				bar: {
					horizontal: false,
					distributed: false,
					startingShape: 'flat',
					columnWidth: '5px',
					dataLabels: {
						enabled: false,
					},
				},
			},
			dataLabels: {
				enabled: false,
				formatter: function (val) {
					return formatMoney(parseInt(val), 0) + ' ';
				},
				offsetY: -20,
				style: {
					fontSize: '12px',
					colors: ['#304758'],
				},
			},

			xaxis: {
				categories: labels,
				position: 'bottom',
				axisBorder: {
					show: false,
				},
				axisTicks: {
					show: false,
				},
				crosshairs: {
					fill: {
						type: 'gradient',
						gradient: {
							colorFrom: '#D8E3F0',
							colorTo: '#BED1E6',
							stops: [0, 100],
							opacityFrom: 0.4,
							opacityTo: 0.5,
						},
					},
				},
				tooltip: {
					enabled: true,
				},
			},
			yaxis: {
				axisBorder: {
					show: false,
				},
				axisTicks: {
					show: false,
				},
				labels: {
					show: false,
					formatter: function (val) {
						return val + ' ';
					},
				},
			},
		},
	};

	//   get fee report
	const [totalMembers, setTotalMembers] = useState(0);
	const [totalAmount, setTotalAmount] = useState(0);

	const [reportLoad, setReportLoad] = useState(false);
	const [reports, setReports] = useState([]);
	const get_servicefee_report = (token) => {
		setReportLoad(true);

		axios.defaults.baseURL = new FinanceService().BASE_URL;
		const reportInstance = axios.create(
			new FinanceService().setHeaders(token)
		);
	reportInstance
		.get('/api/v1/serviceFeeReport/levelOne',
    {
      params: {
        date: Format(new Date(), ['yyyy-MM-dd']),
      },
    }
  )
		.then((res) => {
			const objs = res.data.data;
			const curr = ''; // Assuming currency is not provided in the API result

			console.log('===== report =====', objs);
			if (objs.length === 0) {
				setReportsMessage('No service fee report available today');
			} else {
				const l = [];
				const s = [];
				let tot_tickets = 0;
				let tot_amount = 0;
				objs.forEach((o) => {
					l.push(o.name);
					s.push(parseFloat(o.service_fee)); // Assuming 'service_fee' is the field name for service fee
					tot_tickets += 1; // Increment by 1 for each member
					tot_amount += parseFloat(o.service_fee); // Assuming 'service_fee' is the field name for service fee
				});
				setTotalMembers(tot_tickets);
				setTotalAmount(formatMoney(tot_amount, 0)); // Assuming 'formatMoney' is defined elsewhere
				setLabels(l);
				setAmounts(s);
				setRevenue(s);

				setReports(objs);
				setCurrency(curr);
			}

			setReportLoad(false);
		})
		.catch((err) => {
			setReportLoad(false);
			if (err.response) {
				enqueueSnackbar(err.response.data.message, {
					variant: 'error',
				});
			}

			if (err.message) {
				setReportsMessage(err.message);
				enqueueSnackbar(err.message, {
					variant: 'error',
				});
			}
		});
	};



	// filter report

	// filter dialog
	const [filterDialog, setFilterDialog] = useState(false);

	// filter fines titckets

	const [date, setDate] = useState({
		value: Format(new Date(), ['yyyy-MM-dd']),
		error: '',
	});


	const filter_report = () => {
		setReportLoad(true);

		setTotalMembers(0);
		setTotalAmount(0);
		setLabels([]);
		setAmounts([]);
		setRevenue([]);
		setReports([]);

		var data = {};

	
			data = {
				date: date.value,
        status: status.value
			};
		

		axios.defaults.baseURL = new FinanceService().BASE_URL;
		const reportInstance = axios.create(
			new FinanceService().setHeaders(operatorData.token)
		);
		reportInstance
			.get('/api/v1/serviceFeeReport/levelOne', 
     {
      params: data,
     }
    )
			.then((res) => {
				const objs = res.data.data;
				console.log('===== report =====', objs);
				if (objs.length === 0) {
					setReportsMessage('No service fee report available today');
				} else {
					const l = [];
					const s = [];
					let tot_members = 0;
					let tot_amount = 0;
					objs.forEach((o) => {
						l.push(o['name']); // Assuming 'name' is the field name for member name
						s.push(parseFloat(o['total_sales'])); // Assuming 'total_sales' is the field name for total sales
						tot_members += 1; // Increment by 1 for each member
						tot_amount += parseFloat(o['service_fee']); // Assuming 'service_fee' is the field name for service fee
					});
					setTotalMembers(tot_members);
					setTotalAmount(formatMoney(tot_amount, 0)); // Assuming 'formatMoney' is defined elsewhere
					setLabels(l);
					setAmounts(s);
					setRevenue(s);
					setReports(objs);
					setFilterDialog(false);
				}

				setReportTitle(
					'Service Fee Report On : ' +
						date.value 
				);

				setReportLoad(false);
			})
			.catch((err) => {
				setReportLoad(false);
				if (err.response) {
					enqueueSnackbar(err.response.data.message, {
						variant: 'error',
					});
				}

				if (err.message) {
					setReportsMessage(err.message);
					enqueueSnackbar(err.message, {
						variant: 'error',
					});
				}
			});

	};

	// format money

	function formatMoney(
		amount,
		decimalCount = 2,
		decimal = '.',
		thousands = ','
	) {
		try {
			decimalCount = Math.abs(decimalCount);
			decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

			const negativeSign = amount < 0 ? '-' : '';

			let i = parseInt(
				(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
			).toString();
			let j = i.length > 3 ? i.length % 3 : 0;

			return (
				negativeSign +
				(j ? i.substr(0, j) + thousands : '') +
				i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
				(decimalCount
					? decimal +
					  Math.abs(amount - i)
							.toFixed(decimalCount)
							.slice(2)
					: '')
			);
		} catch (e) {
			console.log(e);
		}
	}

	// level1 data

	const columns1 = [
		{
			name: 'plate_number',
			label: 'Plate Number',
			options: {
				filter: true,
				sort: true,
			},
		},
		{
			name: 'total_sales',
			label: 'Total Sales',
			options: {
				filter: true,
				sort: true,
			},
		},
		{
			name: 'service_fee',
			label: 'Service Fee',
			options: {
				filter: true,
				sort: true,
			},
		},
		{
			name: 'status',
			label: 'Status',
			options: {
				filter: true,
				sort: true,
			},
		},
	];



	const options1 = {
		textLabels: {
			body: {
				noMatch: 'No report available',
			},
		},
		filterType: 'checkbox',
		download: true,
		responsive: 'standard',
		selectableRows: false,
		rowsPerPage: 100,
		elevation: 0,
	};

	/// daily detailed Fee report

	const [detailDialog, setDetailDialog] = useState(false);

	const [status, setStatus] = useState('');

	const [detailedReport, setDetailedReport] = useState([]);
	const [detailedLoad, setDetailedLoad] = useState(false);

  const get_detailed_report = (data) => {
  const memberName = reports.find((r) => r.code === data.member_code)?.name;

  setReportTitle(' for ' + memberName + ' On : ' + date.value);
	setDetailedLoad(true);
	setDetailDialog(true);
	setDetailedReport([]);
	axios.defaults.baseURL = new FinanceService().BASE_URL;
	console.log(new FinanceService().BASE_URL);
	const detailedInstance = axios.create(
		new FinanceService().setHeaders(operatorData.token)
	);
	detailedInstance
		.get('/api/v1/serviceFeeReport/levelTwo', {
			params: data,
		})
		.then((res) => {
			const objs = res.data.data;
			objs.forEach((o, i) => {
				o.id = i + 1;
				o.total_amount =
					formatMoney(parseFloat(o.total_sales), 0) +
					' ' +
					(o.currency ? o.currency : ''); // Assuming 'currency' field is optional
			});
			setDetailedReport(objs);
			setDetailedLoad(false);
		})
		.catch((err) => {
			setDetailedLoad(false);
		});
};


	return (
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
			<div className={classes.root}>
				<Box display='flex'>
					<Box
						display='flex'
						alignItems='center'
						mt={2}
						className={classes.formTitle}
					>
						<Box mr={1}>
							<ConfirmationNumber fontSize='large' color='primary' />
						</Box>{' '}
						<Typography variant='h5' color='default'>
							<b>Service Fee Report</b>
						</Typography>
					</Box>

					<Button
						color='primary'
						variant='outlined'
						startIcon={<FilterList />}
						onClick={() => {
							setFilterDialog(true);
						}}
					>
						Filter
					</Button>
				</Box>

				<Box mt={2}>
					<Grid container spacing={2}>
						<Grid item md={12} lg={12} sm={12} xs={12}>
							<Paper className={classes.paper1} elevation={0}>
								<Grid container>
									<Grid item xs={12} md={12}>
										<Box display='flex' justifyContent='center'>
											<Typography variant='h6'>{reportTitle}</Typography>
										</Box>
									</Grid>
									<Grid item xs={12} md={12}>
										<Chart
											options={revenue_fee.options}
											series={revenue_fee.options.series}
											type='bar'
											height='300px'
										/>
									</Grid>
								</Grid>
							</Paper>
						</Grid>
						<Grid item md={8} lg={8} sm={12} xs={12}>
							{reportLoad && <LinearProgress />}
							<MUIDataTable
								title={reportTitle}
								data={reports}
								columns={columns}
								options={options}
							/>
						</Grid>
						<Grid item md={4} lg={4} sm={12} xs={12}>
							{reportLoad ? (
								<Paper className={classes.paper} elevation={0}>
									<Grid container>
										<Grid item xs={12} md={12}>
											<Box>
												<Typography variant='h6' className={classes.title}>
													servicefee Summary
												</Typography>
											</Box>
										</Grid>

										<Grid item xs={12} md={12}>
											<Grid item lg={12} sm={12} xs={12} md={12}>
												<Box>
													<Box display='flex' justifyContent='center'>
														<Skeleton
															animation='wave'
															variant='circle'
															width={200}
															height={200}
														/>
													</Box>
												</Box>
											</Grid>
										</Grid>
									</Grid>
								</Paper>
							) : (
								<Paper className={classes.paper} elevation={0}>
									<Grid container>
										<Grid item xs={12} md={12}>
											<Box>
												<Typography variant='h6' className={classes.title}>
													Summary
												</Typography>
											</Box>
										</Grid>

										<Grid item xs={12} md={12}>
											<Grid item md={12} lg={12} xs={6} md={8}>
												<Chart
													options={pos_performance.options}
													series={amounts}
													type='pie'
													width={'100%'}
													height={'100%'}
												/>
											</Grid>
										</Grid>

										<Grid item md={6} xs={6} sm={6} lg={6}>
											<Grid container>
												<Grid item sm={12} xs={12} md={12} lg={12}>
													<Typography>Total Members </Typography>
												</Grid>
												<Grid item sm={12} xs={12} md={12} lg={12}>
													<Typography variant='h5'>{totalMembers}</Typography>
												</Grid>
											</Grid>
										</Grid>
										<Grid item md={6} xs={6} sm={6} lg={6}>
											<Grid container>
												<Grid item sm={12} xs={12} md={12} lg={12}>
													<Typography>Total Fees </Typography>
												</Grid>
												<Grid item sm={12} xs={12} md={12} lg={12}>
													<Typography variant='h5'>
														{' '}
														{totalAmount + ' ' + currency}{' '}
													</Typography>
												</Grid>
											</Grid>
										</Grid>
									</Grid>
								</Paper>
							)}
						</Grid>
					</Grid>
				</Box>
			</div>

			{/* filter dialog  */}

			<Dialog
				maxWidth='sm'
				fullWidth
				open={filterDialog}
				onClose={() => {
					setFilterDialog(false);
				}}
				aria-labelledby='filter'
				aria-describedby='filter'
			>
				<DialogTitle id='filter'>{'Filter'}</DialogTitle>
				<DialogContent>
					<DialogContentText>
						<Box>
							<Box mt={1}>
								<FormControl variant='outlined' size='small' fullWidth>
									<InputLabel id='status'>Status</InputLabel>
									<Select
										labelId='Status'
										id='status'
										onChange={(e) => {
											setStatus({ value: e.target.value, error: '' });
										}}
										label='Status'
									>
										<MenuItem value=''>
											<em>All</em>
										</MenuItem>
										<MenuItem value={'PENDING'}>PENDING</MenuItem>
										<MenuItem value={'COMPLETED'}>COMPLETED</MenuItem>
									</Select>
								</FormControl>
							</Box>
							<Box mt={1}>
								<DatePicker
									fullWidth
									disableToolbar
									variant='inline'
									format='yyyy-MM-dd'
									margin='dense'
									autoOk
									label='date'
									value={date.value}
									inputVariant='outlined'
									onChange={(v) => {
										console.log('choosen1: ', Format(v, ['yyyy-MM-dd']));

										setDate({
											value: Format(v, ['yyyy-MM-dd']),
											error: '',
										});
									}}
									InputProps={{
										disableUnderline: true,
										style: { paddingRight: 0 },
									}}
								/>
							</Box>
						</Box>
					</DialogContentText>
				</DialogContent>

				<DialogActions>
					<Button
						onClick={() => {
							setFilterDialog(false);
						}}
						color='secondary'
						className={classes.btn}
					>
						<Typography>Close</Typography>
					</Button>

					<Button
						onClick={() => {
							filter_report();
						}}
						color='primary'
						variant='contained'
						className={classes.btn}
					>
						{reportLoad ? (
							<CircularProgress size={25} color='secondary' />
						) : (
							<Typography>View</Typography>
						)}
					</Button>
				</DialogActions>
			</Dialog>

			{/* daily detailed report  */}

			<Dialog
				fullScreen
				open={detailDialog}
				style={{ marginTop: '80px' }}
				onClose={() => {}}
				TransitionComponent={Transition}
			>
				<AppBar className={classes.appBar}>
					<Toolbar>
						<IconButton
							edge='start'
							color='inherit'
							onClick={() => {
								setDetailDialog(false);
							}}
							aria-label='close'
						>
							<Close />
						</IconButton>
						<Typography variant='h6' className={classes.title}>
							Tickets
						</Typography>

						<Button
							autoFocus
							color='inherit'
							onClick={() => {
								setDetailDialog(false);
							}}
						>
							Close
						</Button>
					</Toolbar>
				</AppBar>

				<Box mt={2}>
					{detailedLoad && <LinearProgress />}
					<MUIDataTable
						title={'Detailed Report' + ' ' + reportTitle}
						data={detailedReport}
						columns={columns1}
						options={options1}
					/>
				</Box>
			</Dialog>
		</MuiPickersUtilsProvider>
	);
}

export default withLocalize(ServiceFeeReport);
